import $ from 'jquery';

import {
	itemsObject,
	getDOMElements,
} from '../common/utilities';

// Import utilities
const {
	addParametersUTM,
	isDefined,
	isEmpty
} = _uo.utility;

import ItemCreatorIntegrations from '../item/integrations-grid.js';
import Triggers                from '../item/triggers';
import Actions                 from '../item/actions';

import MetaboxItems            from './items';

class MetaboxFooter {

	constructor( itemType ){
		this.itemType = itemType;

		if ( this.shouldCreateMetaboxFooter() ){
			this.createFooter();
		}
	}

	shouldCreateMetaboxFooter(){
		// Check if we should create the metabox
		// For the triggers we're going to create it always,
		// but for the actions we're going to create only if there is at least one action

		let create = false;

		if ( this.itemType == 'trigger' ){
			// Get triggers
			let recipeActions = itemsObject( 'get', {
				filter: {
					itemType: 'trigger'
				}
			});

			// Check if has triggers
			let hasTriggers = ! isEmpty( recipeActions );

			// Create metabox if hasTriggers
			if ( ( hasTriggers || ( ! UncannyAutomator._site.automator.has_pro ) ) || UncannyAutomator._recipe.recipe_type == 'anonymous' ){
				create = true;
			}
		}

		if ( this.itemType == 'action' ){
			// Get actions
			let recipeActions = itemsObject( 'get', {
				filter: {
					itemType: 'action'
				}
			});

			// Check if has actions
			let hasActions = this.hasLoops || ! isEmpty( recipeActions );

			// Create metabox if hasActions
			if ( hasActions || ! isEmpty( UncannyAutomator.recipe.conditions ) ){
				create = true;
			}
		}

		return create;
	}

	createFooter(){
		// Create error container
		let container  = $( '<div/>', { 'class': 'metabox__footer' });

		// "Add another" button
		const $addAnother = document.createElement( 'uo-button' );
		$addAnother.setAttribute( 'color', 'secondary' );

		// Add button, but don't add it in the triggers metabox for anonymous recipes
		if ( this.itemType == 'action' || ( this.itemType == 'trigger' && UncannyAutomator._recipe.recipe_type == 'user' ) ){
			// Append "Add another" button
			container.append( $addAnother );
		}

		if ( this.itemType == 'trigger' ){
			// Do only for "user" recipes
			if ( UncannyAutomator._recipe.recipe_type == 'user' ){
				// Set text to the "Add Another" button
				$addAnother.innerText = UncannyAutomator._core.i18n.trigger.addAnother;
			}

			// Do only for "anonymous" recipes
			if ( UncannyAutomator._recipe.recipe_type == 'anonymous' ){
				// Create and append anonymous notice
				let $anonymousNotice = this.createAnonymousNotice();
				container.append( $anonymousNotice );
			}
		}

		if ( this.itemType == 'action' ){
			// Set text to the "Add Another" button
			$addAnother.innerText = UncannyAutomator._core.i18n.action.addAnother;
			container.addClass('add-action-btn');
		}

		// Add button to add filter
		if ( this.itemType == 'action' && UncannyAutomator._site.automator.has_pro ){
			container.get(0).insertAdjacentHTML( 'beforeEnd', `
				<uo-button-dropdown class="uap-metabox-footer-buttons">
					<uo-button 
						slot="target" 
						color="secondary"
					>
						${ UncannyAutomator._core.i18n.add } <uo-icon id="angle-down"></uo-icon>
					</uo-button>

					<ua-builder-conditions-add-button
						color="transparent"
					>
						${ UncannyAutomator._core.i18n.conditions.filter }
					</ua-builder-conditions-add-button>

					<uap-builder-loop-add-user-loop
						color="transparent"
					></uap-builder-loop-add-user-loop>

					${ 
						_uo.utility.versionCompare( 
							UncannyAutomator._site.automator.version_pro, 
							'5.3', 
							'>=' 
						) ? 
						`<uap-builder-loop-add-post-loop
							color="transparent"
						></uap-builder-loop-add-post-loop>` : ''
					}
				</uo-button-dropdown>
			` );
		}

		// Bind button
		if ( ( this.itemType == 'trigger' && UncannyAutomator._recipe.recipe_type == 'user' ) || this.itemType == 'action' ){
			// Listen clicks to the "Add another" button
			$addAnother.addEventListener( 'click', () => {
				// Close any open conditions actions
				new Actions();

				// Multiple triggers are only allowed in the pro version
				// So we're only doing this for actions
				new ItemCreatorIntegrations( this.itemType );
			} );
		}

		// Append to the metabox
		let metabox = getDOMElements( 'metabox', {
			type: this.itemType
		})

		metabox.append( container );
	}

	createAnonymousNotice(){
		let $notice = $( `
			<div class="description">
				${ UncannyAutomator._core.i18n.recipeType.everyoneOnlyOneTrigger } <a href="${ addParametersUTM( 'https://automatorplugin.com/knowledge-base/managing-triggers/', {
						'medium':  'anonymous_recipe_one_trigger',
						'content': 'learn_more'
					}) }" target="_blank">${ UncannyAutomator._core.i18n.learnMore } <uo-icon id="external-link"></uo-icon></a>
			</div>
		` );

		return $notice;
	}

	get hasLoops () {
		return UncannyAutomator._recipe.actions.items.filter( item => item.type === 'loop' ).length > 0;	
	}
}

export default MetaboxFooter;